import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCateringEventCategories } from '../../api/fetch-catering-event-categories';

export const fetchCateringEventCategoriesThunk = createAsyncThunk(
    'fetchCateringEventCategories',
    async () => fetchCateringEventCategories(),
);
